import { render, staticRenderFns } from "./OrdersAgenda.vue?vue&type=template&id=4c0cd014"
import script from "./OrdersAgenda.vue?vue&type=script&lang=js"
export * from "./OrdersAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports